@use '../@shared/global' as *;
